<template>
  <div class="kpi cx-card-height"> 
    <head-text  :kpi="ExplorationKpi"
                :isSmall="isSmall"
                :pillValue="ActionsToTake">
    </head-text>

    <item :thresholdData="colorRange" 
          :round="true" 
          :isSmall="isSmall" 
          :kpi="ExplorationKpi">
    </item>


    <b-card-text class="inner-card">
      <div v-if="AdvertisementCardCountMax || AdvertisementPlaceholderCount">
        <p class="mb-2" style="color: grey">
          {{ $t("Webportal.CX.Dashboard.Exploration.Reviews") }}
        </p>

        <!-- Google sub card -->
        <ExplorationSubCard v-if="showExplorationSubCard(GoogleData)"
                            :logo="GoogleData.PictureURL"
                            :explorationData="GoogleData"
                            :class="{ 'dark-items': darkMode }"
                            :showBadges="showBadges"
                            @toggle-popup="togglePopup(Google)" />

        <!-- Facebook sub card -->
        <!-- <ExplorationSubCard v-if="showExplorationSubCard(FacebookData)" -->
        <ExplorationSubCard v-if="false"
                            :logo="FacebookData.PictureURL"
                            :explorationData="FacebookData"
                            :class="{ 'dark-items': darkMode }"
                            :showBadges="showBadges"
                            @toggle-popup="togglePopup(Facebook)" />

        <!-- Autoscout sub card -->
        <ExplorationSubCard
          v-if="showExplorationSubCard(AutoscoutData)"
          :logo="AutoscoutData.PictureURL"
          :class="{ 'dark-items': darkMode }"
          :explorationData="AutoscoutData"
          :showBadges="showBadges"
          @toggle-popup="togglePopup(Autoscout)"
        />

        <!-- Mobile sub card -->
        <ExplorationSubCard
          v-if="showExplorationSubCard(MobileData)"
          :logo="MobileData.PictureURL"
          :class="{ 'dark-items': darkMode }"
          :explorationData="MobileData"
          :showBadges="showBadges"
          @toggle-popup="togglePopup(Mobile)"
        />

        <!-- Autocasion sub card -->
        <ExplorationSubCard
          v-if="showExplorationSubCard(AutocasionData)"
          :logo="AutocasionData.PictureURL"
          :class="{ 'dark-items': darkMode }"
          :explorationData="AutocasionData"
          :showBadges="showBadges"
          @toggle-popup="togglePopup(Autocasion)"
        />

        <!-- Marktplaats sub card -->
        <ExplorationSubCard
          v-if="showExplorationSubCard(MarktplaatsData)"
          :logo="MarktplaatsData.PictureURL"
          :class="{ 'dark-items': darkMode }"
          :explorationData="MarktplaatsData"
          :showBadges="showBadges"
          @toggle-popup="togglePopup(Marktplaats)"
        />

        <!-- Advertisement Placeholders -->
        <ExplorationSubCard
          v-for="ad_index in AdvertisementPlaceholderCount" :key="ad_index"
          :overrideText="$t('Webportal.CX.Dashboard.Exploration.AdvertisementPlaceholder', { i: ActiveApisCount + ad_index })"          
          :overrideShowToggle="true"
          :class="{ 'dark-items': darkMode }"
          :showBadges="showBadges"
          @toggle-popup="ShowAdvertisement = !ShowAdvertisement"
        />
      </div>

      <div v-if="showExplorationSubCard(SeobilityData)">
        <p class="mt-2 mb-2" style="color: grey">
          {{ $t("Webportal.CX.Dashboard.Exploration.Seobility") }}
        </p>

        <!-- Seobility sub card -->
        <ExplorationSubCard
          :logo="SeobilityData.PictureURL"
          :logoBackgroundColor="Seobility.LogoBG"
          :class="{ 'dark-items': darkMode }"
          :explorationData="SeobilityData"
          :showBadges="showBadges"
          @toggle-popup="togglePopup(Seobility)"
        />
      </div>

      <!-- AFS categories -->
      <template v-for="(category, cat_index) in AFSCategories">
        <p class="mb-2" style="color: grey" :key="'AFS_Category_' + cat_index">
          {{ $t(category.TranslationString) }}
        </p>

        <!-- AFS in category -->
        <template v-for="(afs, index) in category.AFSItems">
          <template v-if="afs.Scenarios">
            <span :key="`rf_${cat_index}_${index}`" class="scenario-legend">
              {{ $t("Webportal.CX.Dashboard.Exploration_NoExp.Legend") }}
            </span>

            <br :key="`rf_${cat_index}_${index}_br`" />
          </template>

          <ExplorationSubCard
            :key="`Survey_${afs.ExternalSurveyId}`"
            :explorationData="afs"
            :logo="afs.LogoUrl"
            :showBadges="showBadges"
            @toggle-popup="toggleSurveyPopup(afs)"
          />

          <SurveyPopup
            v-show="afs.ShowPopup"
            :surveyData="afs"
            :headLine="LocationName"
            :clientLocationId="ExplorationAugmentionData.ClientLocationId"
            @close="toggleSurveyPopup(afs)"
            :style="{ top: calcTop(160, index) + 'px', left: calcLeft(650, index) + 'px' }"
            class="popup survey-popup"
            :ref="`popup_Survey_${afs.ExternalSurveyId}`"
            :key="`Survey_Popup_${afs.ExternalSurveyId}`"
          />
        </template>
      </template>
    </b-card-text>

    <!-- Google Popup  -->
    <template v-if="GoogleData && !GoogleData.Inactive">
      <GooglePopup
        v-show="Google.ShowPopup"
        :googleData="GoogleData"
        :headLine="LocationName"
        @close="Google.ShowPopup = false"
        @open-competitor="openCompetitor(Google, ...arguments)"
        class="popup google-popup"
        :style="{ top: 160 + 'px', left: 470 + 'px' }"
        ref="popup_Google"
      />

      <GooglePopup
        v-for="(compId, index) in Google.Competitors"
        :key="`Google_${compId}`"
        :isCompetitor="true"
        :competitorId="compId"
        @close="Google.Competitors.splice(index, 1)"
        class="popup google-popup"
        :style="{ top: calcTop(160, index) + 'px', left: calcLeft(470, index) + 'px' }"
      />
    </template>

    <template v-if="false">
    <!-- <template v-if="FacebookData && !FacebookData.Inactive"> -->
      <FacebookPopup  v-show="Facebook.ShowPopup"
                      :facebookData="FacebookData"
                      :headLine="LocationName"
                      @close="Facebook.ShowPopup = false"
                      class="popup facebook-popup"
                      :style="{ top: 160 + 'px', left: 470 + 'px' }"
                      ref="popup_Facebook" />
                      <!-- @open-competitor="openCompetitor(Facebook, ...arguments)" -->
    </template>

    <!-- Seobility Popup -->
    <template v-if="SeobilityData && !SeobilityData.Inactive">
      <SeobilityPopup
        v-show="Seobility.ShowPopup"
        :seobilityData="SeobilityData"
        :headLine="LocationName"
        @close="Seobility.ShowPopup = false"
        @open-competitor="openCompetitor(Seobility, ...arguments)"
        class="popup seobility-popup"
        :style="{ top: 190 + 'px', left:  500 + 'px' }"
        ref="popup_Seobility"
      />

      <SeobilityPopup
        v-for="(compId, index) in Seobility.Competitors"
        :key="`Seo_${compId}`"
        :isCompetitor="true"
        :competitorId="compId"
        @close="Seobility.Competitors.splice(index, 1)"
        class="popup seobility-popup"
        :style="{ top: calcTop(190, index) + 'px', left: calcLeft(500, index) + 'px' }"
      />
    </template>

    <!-- Autoscout Popup  -->
    <template v-if="AutoscoutData && !AutoscoutData.Inactive">
      <AutoscoutPopup
        v-show="Autoscout.ShowPopup"
        :autoscoutData="AutoscoutData"
        :headLine="LocationName"
        @close="Autoscout.ShowPopup = false"
        @open-competitor="openCompetitor(Autoscout, ...arguments)"
        class="popup autoscout-popup"
        :style="{ top: 160 + 'px', left:  530 + 'px' }"
        ref="popup_Autoscout"
      />

      <AutoscoutPopup
        v-for="(compId, index) in Autoscout.Competitors"
        :key="`Autoscout_${compId}`"
        :isCompetitor="true"
        :competitorId="compId"
        @close="Autoscout.Competitors.splice(index, 1)"
        :style="{ top: calcTop(160, index) + 'px', left: calcLeft(530, index) + 'px' }"
        class="popup autoscout-popup"
      />
    </template>

    <!-- Mobile Popup -->
    <template v-if="MobileData && !MobileData.Inactive">
      <MobilePopup
        v-show="Mobile.ShowPopup"
        :mobileData="MobileData"
        :headLine="LocationName"
        @close="Mobile.ShowPopup = false"
        @open-competitor="openCompetitor(Mobile, ...arguments)"
        class="popup mobile-popup"
        :style="{ top: 190 + 'px', left:  560 + 'px' }"
        ref="popup_Mobile"
      />

      <MobilePopup
        v-for="(compId, index) in Mobile.Competitors"
        :key="`Mobile_${compId}`"
        :isCompetitor="true"
        :competitorId="compId"
        @close="Mobile.Competitors.splice(index, 1)"
        :style="{ top: calcTop(190, index) + 'px', left: calcLeft(560, index) + 'px' }"
        class="popup mobile-popup"
      />
    </template>

    <!-- Autocasion Popup  -->
    <template v-if="AutocasionData && !AutocasionData.Inactive">
      <AutocasionPopup
        v-show="Autocasion.ShowPopup"
        :autocasionData="AutocasionData"
        :headLine="LocationName"
        @close="Autocasion.ShowPopup = false"
        @open-competitor="openCompetitor(Autocasion, ...arguments)"
        class="popup autocasion-popup"
        :style="{ top: 160 + 'px', left:  590 + 'px' }"
        ref="popup_Autocasion"
      />

      <AutocasionPopup
        v-for="(compId, index) in Autocasion.Competitors"
        :key="`Autocasion_${compId}`"
        :isCompetitor="true"
        :competitorId="compId"
        @close="Autocasion.Competitors.splice(index, 1)"
        :style="{ top: calcTop(160, index) + 'px', left: calcLeft(590, index) + 'px' }"
        class="popup autocasion-popup"
      />
    </template>

    <!-- Marktplaats Popup  -->
    <template v-if="MarktplaatsData && !MarktplaatsData.Inactive">
      <MarktplaatsPopup
        v-show="Marktplaats.ShowPopup"
        :marktplaatsData="MarktplaatsData"
        :headLine="LocationName"
        @close="Marktplaats.ShowPopup = false"
        @open-competitor="openCompetitor(Marktplaats, ...arguments)"
        class="popup marktplaats-popup"
        :style="{ top: 190 + 'px', left:  620 + 'px' }"
        ref="popup_Marktplaats"
      />

      <MarktplaatsPopup
        v-for="(compId, index) in Marktplaats.Competitors"
        :key="`Marktplaats_${compId}`"
        :isCompetitor="true"
        :competitorId="compId"
        @close="Marktplaats.Competitors.splice(index, 1)"
        :style="{ top: calcTop(190, index) + 'px', left: calcLeft(620, index) + 'px' }"
        class="popup marktplaats-popup"
      />
    </template>

    <!-- Advertisement Popup -->
    <template v-if="ShowAdvertisement">
      <GenericPopup
        :headLine="$t('Webportal.CX.Dashboard.Exploration.AdvertisementPlaceholder', { i: '' })"
        :innerHtml="AdvertisementPopupText"
        @close="ShowAdvertisement = false"
        class="popup advertisement-popup"
        :style="{ top: calcTop(220) + 'px', left: calcLeft(0) + 'px' }"
      />
    </template>
  <!-- </b-card> -->
 </div>
</template>

<script>
import ExplorationSubCard from "./ExplorationSubCard";
import GooglePopup from "./ExplorationGooglePopup-bmw";
import FacebookPopup from "./ExplorationFacebookPopup";
import MobilePopup from "./ExplorationMobilePopup";
import AutoscoutPopup from "./ExplorationAutoscoutPopup";
import SeobilityPopup from "./ExplorationSeobilityPopup";
import AutocasionPopup from "./ExplorationAutocasionPopup";
import MarktplaatsPopup from "./ExplorationMarktplaatsPopup";
import SurveyPopup from "./ExplorationSurveyPopup";
import GenericPopup from "./GenericPopup";
import EventBus from "@/services/EventBus";
import HeadText from '@/components/CX/Map/KpiHeader';
import Item from '@/components/CX/Map/KpiItem';
import Spacer from '@/components/CX/Map/KpiSpacer';
import NumbersMixin from '@/mixins/NumbersMixin.js';

export default {
  name: "ExplorationCard",

  mixins: [
    NumbersMixin
  ],

  components: {
    ExplorationSubCard,
    GooglePopup,
    FacebookPopup,
    MobilePopup,
    AutoscoutPopup,
    SeobilityPopup,
    AutocasionPopup,
    MarktplaatsPopup,
    SurveyPopup,
    GenericPopup,
    HeadText,
    Item,
    Spacer
  },

  props: {
    darkMode: {
      type: Boolean,
      default: false
    },
    isSmall: {type: Boolean, default: false },
    colorRange: Array,
    LocationName: String,
    ExplorationScore: Number,
    ExplorationAugmentionRealm: String,
    AdvertisementCardCountMax: {
      type: Number,
      default: () => 2
    },
    GoogleData: {
      type: Object,
      default: () => {}
    },
    FacebookData: {
      type: Object,
      default: () => {}
    },
    SeobilityData: {
      type: Object,
      default: () => {}
    },
    AutoscoutData: {
      type: Object,
      default: () => {}
    },
    MobileData: {
      type: Object,
      default: () => {}
    },
    AutocasionData: {
      type: Object,
      default: () => {}
    },
    MarktplaatsData: {
      type: Object,
      default: () => {}
    },
    ExplorationAugmentionData: {
      type: Object,
      default: () => {}
    },
    showBadges: {
      type: Boolean,
      default: false
    },
  },

  mounted() {
    EventBus.$on('Resolved_FirstAidKit', () => { this.ActionsToTakeCount--; });
  },

  beforeDestroy() {
    EventBus.$off('Resolved_FirstAidKit');
  },

  computed: {
    ExplorationKpi() {
      return { 
        NameShort: this.$t(`Webportal.CX.Dashboard.Exploration${this.ExplorationAugmentionRealm || ''}`),
        Result: (this.ExplorationScore || this.ExplorationScore == 0) ? this.ExplorationScore : undefined
      };
    },

    ActionsToTake: function() {
      return !this.ExplorationAugmentionRealm ? this.ActionsToTakeCount :
        _(this.ExplorationAugmentionCategories).flatMap(c => c.AFSItems)
          .flatMap(afs => afs.Scenarios).countBy('IsAccomplished').value().false || 0;
    },

    CountApis: function() {
      return _.countBy(["Autoscout", "Mobile", "Autocasion", "Marktplaats"],
        apiName => !!this.showExplorationSubCard(this[apiName + 'Data'])
      );
    },

    AdvertisementPlaceholderCount: function() {
      // Clamp min to 0 elements
      return Math.max(0, this.AdvertisementCardCountMax - (this.CountApis.true || 0));
    },

    ActiveApisCount: function() {
      return this.CountApis.true ? !null : 0;
    },

    AFSCategories: function() {
      try {
        return Object.values(this.ExplorationAugmentionCategories || {});
      } catch (error) {
        console.error(error);
        return {};
      } 
    },

    ExplorationAugmentionCategories: function() {
      let category = `Categories${this.ExplorationAugmentionRealm || ''}`;
      let items = this.ExplorationAugmentionData ? this.ExplorationAugmentionData[category] : null;
      return items
    },
    AdvertisementPopupText: function() {
      let i = 0, res = '', req = '', output = '';
      do {
        output += res || '';
        req = 'Webportal.CX.Dashboard.Exploration.Advertisement_' + (++i);
        res = this.$t(req, { br: '<br>', li: '<li>', _li: '</li>', ul: '<ul>', _ul: '</ul>' })
      }
      while (res != req);
      return output;
    }
  },

  data() {
    return {
      Google: {
        ShowPopup: false,
        Value: 2,
        MaxRating: 5,
        Name: "Google",
        Competitors: []
      },

      Facebook: {
        ShowPopup: false,
        Value: 2,
        MaxRating: 5,
        Name: "Facebook",
        Competitors: []
      },

      Seobility: {
        ShowPopup: false,
        LogoBG: "#327BB4",
        Value: 70,
        MaxRating: 100,
        Name: "Seobility",
        Competitors: []
      },

      Mobile: {
        ShowPopup: false,
        Value: 2,
        MaxRating: 5,
        Name: "Mobile",
        Competitors: []
      },

      Autoscout: {
        ShowPopup: false,
        Value: 2,
        MaxRating: 5,
        Name: "Autoscout",
        Competitors: []
      },

      Autocasion: {
        ShowPopup: false,
        Value: 2,
        MaxRating: 5,
        Name: "Autocasion",
        Competitors: []
      },

      Marktplaats: {
        ShowPopup: false,
        Value: 2,
        MaxRating: 5,
        Name: "Marktplaats",
        Competitors: []
      },

      ActionsToTakeCount: 0,
      ActiveApis: 0,

      ShowAdvertisement: false
    };
  },

  watch: {
    MobileData: {
      immediate: true,
      handler(val, oldVal) {
        this.parseDatesForReviews(this?.MobileData?.Reviews);

        if (!this?.MobileData?.Ratings || !this?.MobileData?.RatingsByName)
          return;

        // Remove percentage and RatingsCount from ratings to use v-for
        // They are used via RatingsByName instead
        this.MobileData.Ratings = [];
        if (this.MobileData.RatingsByName.ResponseTime)
          this.MobileData.Ratings.push(this.MobileData.RatingsByName.ResponseTime);
        if (this.MobileData.RatingsByName.Friendliness)
          this.MobileData.Ratings.push(this.MobileData.RatingsByName.Friendliness);
        if (this.MobileData.RatingsByName.Consulting)
          this.MobileData.Ratings.push(this.MobileData.RatingsByName.Consulting);
      }
    },

    AutoscoutData: {
      immediate: true,
      handler(val, oldVal) {
        this.parseDatesForReviews(this?.AutoscoutData?.Reviews);

        if (!this?.AutoscoutData?.Ratings) return;

        // Filter out non star ratings
        this.AutoscoutData.Ratings = _.filter(
          this.AutoscoutData.Ratings,
          r => r.Name != "ReviewCount" && r.Name != "Recommendation"
        );
      }
    },

    GoogleData: {
      immediate: true,
      handler(val, oldVal) {
        this.parseDatesForReviews(this?.GoogleData?.Reviews);

        // Count ActionsToTake and set missing objects
        // offset by not accomplished apis from surveys
        this.ActionsToTakeCount = this.ExplorationAugmentionData?.ExplorationAugmentionCount || 0;
        this.ActiveApis = 0;
        ["Autoscout", "Google", "Seobility", "Mobile", "Autocasion", "Marktplaats"].forEach(apiName => {
          var api = this?.[apiName + "Data"];
          if (!api) return;

          if (api.Threshold && !api.Inactive) {
            this.ActiveApis++;

            if (api.Threshold.IsAccomplished === false) {
              this.ActionsToTakeCount++;
            }
          } else {
            api.Threshold = {
              IsAccomplished: false,
              Value: 0,
              MaxRating: this[apiName]?.MaxRating
            };
          }
        });
      }
    },

    FacebookData: {
      immediate: true,
      handler(val, oldVal) {
        this.parseDatesForReviews(this?.GoogleData?.Reviews);

        // Count ActionsToTake and set missing objects
        // offset by not accomplished apis from surveys
        this.ActionsToTakeCount = this.ExplorationAugmentionData?.ExplorationAugmentionCount || 0;
        this.ActiveApis = 0;
        ["Autoscout", "Google", "Facebook", "Seobility", "Mobile", "Autocasion", "Marktplaats"].forEach(apiName => {
          var api = this?.[apiName + "Data"];
          if (!api) return;

          if (api.Threshold && !api.Inactive) {
            this.ActiveApis++;

            if (api.Threshold.IsAccomplished === false) {
              this.ActionsToTakeCount++;
            }
          } else {
            api.Threshold = {
              IsAccomplished: false,
              Value: 0,
              MaxRating: this[apiName]?.MaxRating
            };
          }
        });
      }
    },
    AutocasionData: {
      immediate: true,
      handler(val, oldVal) {
        this.parseDatesForReviews(this?.AutocasionData?.Reviews);
      }
    },

    MarktplaatsData: {
      immediate: true,
      handler(val, oldVal) {
      }
    },

    ExplorationAugmentionData: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.ExplorationAugmentionData)
          return;
        try {
          // Parsing all logo urls here as they are used in ExplorationSubCard and the popup
          this.ExplorationAugmentionCategories?.forEach(category => {
            category?.AFSItems?.forEach(afs => {
              if (this.isNumeric(afs.OverrideText)) {
                afs.LogoUrl = this.getMappedLogo(afs.OverrideText);
                delete afs.OverrideText;
              }
            });
          });
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  methods: {
    calcTop(pos, index) {
      return Math.min(pos + ((index || 0) + 1) * 30, window.innerHeight - 500);
    },

    calcLeft(pos, index) {
      return Math.min(pos + ((index || 0) + 1) * 200, window.innerWidth - 500);
    },

    showExplorationSubCard(expData) {
      /* "N / A": !expData || !expData.Inactive */
      return expData && !expData.Inactive && expData.Threshold;
    },

    parseDatesForReviews(reviewArray) {
      if (!reviewArray) return;

      reviewArray = reviewArray.map(review => {
        if (!(review.Time instanceof Date)) review.Time = new Date(review.Time);

        if (!(review.ReplyTime instanceof Date) && !_.isEmpty(review.ReplyTime))
          review.ReplyTime = new Date(review.ReplyTime);

        return review;
      });
    },

    getColor(value) {
      if (!this.colorRange) return null;

      return this.colorRange.find(
        thres => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    },

    togglePopup(expObj) {
      // Newly opened elements should be topmost!
      if (!expObj.ShowPopup) {
        EventBus.$emit(
          "set-topmost-element",
          this.$refs["popup_" + expObj.Name].$el
        );
      }

      expObj.ShowPopup = !expObj.ShowPopup;
    },

    toggleSurveyPopup(surObj) {
      let popupRef = this.$refs["popup_Survey_" + surObj.ExternalSurveyId][0];

      // If the object has no 'ShowPopup', it was not shown yet.
      // If this is the case, we have to trigger the data loading.
      if (surObj.ShowPopup == undefined) {
        popupRef.AcquireData();
      }

      // Newly opened elements should be topmost!
      // Setting a ref in v-for-loop results in an array..
      if (!surObj.ShowPopup) {
        EventBus.$emit(
          "set-topmost-element",
          popupRef.$el
        );
      }

      surObj.ShowPopup = !surObj.ShowPopup;
      this.$forceUpdate();
    },

    openCompetitor(api, competitorId) {
      if (_.indexOf(api.Competitors, competitorId) < 0) {
        api.Competitors.push(competitorId);
      } else {
        _.remove(api.Competitors, function(c) {
          return c === competitorId;
        });
        this.$forceUpdate();
      }
    },

    getMappedLogo(input) {
      if (!this.isNumeric(input)) {
        console.error(`Failed mapping answer '${input}' to icon, as it is not numeric.`);
        return null;
      }

      // Cast string to number
      switch(input * 1)
      {
        case  1: return 'img/aaa-auto-logo.png';
        case  2: return 'img/arabam-logo.png';
        case  3: return 'img/auto-esa-logo.jpg';
        case  4: return 'img/autoscout-logo.png';
        case  5: return 'img/autouncle-logo.png';
        case  6: return 'img/car-for-you-logo.png';
        case  7: return 'img/coches-logo.png';
        case  8: return 'img/gaspedaal-logo.png';
        case  9: return 'img/le-parking-logo.jpg';
        case 10: return 'img/leboncoin-logo.jpg';
        case 11: return 'img/luxauto-logo.png';
        case 12: return 'img/marktplaats-logo.png';
        case 13: return 'img/mobile-logo.png';
        case 14: return 'img/olx-logo.jpg';
        case 15: return 'img/ooyyo-logo.jpg';
        case 16: return 'img/otoshops-logo.jpg';
        case 17: return 'img/willhaben-logo.jpg';
        default:
          console.error(`Failed mapping answer '${input}' to icon. Option is not valid.`);
          return null; // TODO: Placeholder?
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";


.cx-card-tgt .card {
  padding: 0.5rem !important;
}
.card-h {
   min-height: 500px;
}
.msm-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.lines-2 {
  /* min-height: 4.5rem; */
  min-height: 5.25rem;
}
.scenario-legend {
  font-size: 14px;
  float: right;
  margin-right: 8px;
}
.popup {
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
  min-height: 530px;
  max-height: 530px;
  border: none;
}

.google-popup {
  width: 500px;
}

.facebook-popup {
  width: 500px;
}

.seobility-popup {
  width: 700px;
  min-height: 450px;
  max-height: 450px;
}
.survey-popup {
  width: 700px;
  min-height: 450px;
  max-height: 800px;
}
.autoscout-popup {
  width: 740px;
}
.mobile-popup {
  width: 640px;
}
.autocasion-popup {
  width: 500px;
}
.marktplaats-popup {
  width: 740px;
}
.advertisement-popup {
  width: 610px;
  height: 280px;
  min-height: 250px;
  max-height: 400px;
}
</style>
